// src/components/projects/ProjectDetailOverview.jsx
import React, { useEffect } from 'react';
import { useOutletContext, Link } from 'react-router-dom';
import { Grid, Box } from '@mui/material';

// Import styled components
import {
  SectionContainer
} from '../../components/ui';

import useTaskStore from '../../stores/taskStore';
import useActivityStore from '../../stores/activityStore';

// Import extracted components
import ProgressSection from './overview/ProgressSection';
import UpcomingMilestones from './overview/UpcomingMilestones';
import RecentTasks from './overview/RecentTasks';
import TeamSection from './overview/TeamSection';
import ProjectDetailsCard from './overview/ProjectDetailsCard';
import QuickActionsCard from './overview/QuickActionsCard';
import ActivitySection from './overview/ActivitySection';

/**
 * Enhanced project detail overview component
 * Serves as the main overview tab in the project container
 */
const ProjectDetailOverview = () => {
  const { project, canEdit } = useOutletContext();
  
  // Stores
  const {
    projectTasks,
    fetchProjectTasks,
    isLoading: isLoadingTasks
  } = useTaskStore();
  
  const {
    projectActivities,
    fetchProjectActivities,
    loadMoreProjectActivities,
    isLoading: isLoadingActivities
  } = useActivityStore();
  
  // Load tasks and activities
  useEffect(() => {
    if (project?._id) {
      fetchProjectTasks(project._id, { limit: 5 });
      fetchProjectActivities(project._id, { limit: 8 });
    }
  }, [project, fetchProjectTasks, fetchProjectActivities]);
  
  if (!project) return null;
  
  // Get recent tasks
  const recentTasks = projectTasks[project._id]?.slice(0, 5) || [];
  
  // Get recent activities
  const activities = projectActivities[project._id] || [];
  
  return (
    <Box sx={{ px:2, py:2}}>
      <Grid container spacing={2}>
        {/* Left column - Main content */}
        <Grid item xs={12} md={8}>
          {/* <SectionContainer>
            <ProgressSection project={project} />
          </SectionContainer> */}

          {/* <SectionContainer>
            <UpcomingMilestones project={project} />
          </SectionContainer> */}

          <SectionContainer>
            <RecentTasks
              project={project}
              recentTasks={recentTasks}
              isLoading={isLoadingTasks}
              canEdit={canEdit}
            />
          </SectionContainer>

          <SectionContainer>
            <ActivitySection
              activities={activities}
              isLoading={isLoadingActivities}
              project={project}
              loadMoreProjectActivities={loadMoreProjectActivities}
            />
          </SectionContainer>
        </Grid>

        {/* Right column - Sidebar */}
        <Grid item xs={12} md={4}>
          {/* <SectionContainer>
            <TeamSection project={project} canEdit={canEdit} />
          </SectionContainer> */}

          <SectionContainer>
            <ProjectDetailsCard project={project} />
          </SectionContainer>

          <SectionContainer>
            <QuickActionsCard project={project} canEdit={canEdit} />
          </SectionContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProjectDetailOverview;